import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "downChevronBold",
  "use": "downChevronBold-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"downChevronBold\"><path d=\"M0 0h24v24H0z\" fill=\"none\" /><path fill=\"none\" stroke-width=\"2\" stroke-linejoin=\"round\" stroke-linecap=\"round\" stroke=\"currentColor\" d=\"M8 10l4 4 4-4\" data-name=\"↳color\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol